import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserPreferredLocale, languageNames } from '../locales';

interface LanguageDetectionProps {
  onClose: () => void;
}

const LanguageDetection: React.FC<LanguageDetectionProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const detectedLocale = getUserPreferredLocale();
  
  // 如果检测到的是英语，不显示提示
  if (detectedLocale === 'en') {
    return null;
  }

  const handleSwitchLanguage = () => {
    navigate(`/${detectedLocale}`);
    onClose();
  };

  const handleStayEnglish = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md mx-4">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Language Detection
          </h3>
          
          <p className="text-gray-600 mb-6">
            We detected you might be in{' '}
            <span className="font-semibold text-blue-600">
              {languageNames[detectedLocale]}
            </span>
          </p>
          
          <div className="flex flex-col gap-3">
            <button
              onClick={handleSwitchLanguage}
              className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg font-medium transition-colors"
            >
              Switch to {languageNames[detectedLocale]}
            </button>
            
            <button
              onClick={handleStayEnglish}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-medium transition-colors"
            >
              Stay in English
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageDetection; 